import "../src/App.css";
import Header from "./components/header/Header";
import Home from "./components/home/Home";
import ComingSoonOverlay from "./components/ComingSoonOverlay";

function App() {
  return (
    <div className="App">
      <Header />
      <main className="main">
        <Home />
        <ComingSoonOverlay />
      </main>
    </div>
  );
}

export default App;
